import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import PanelButton from '~/components/panels/PanelButton.vue';
import Dials from '~/components/Dials.vue';
import Card from '~/components/cards/Card.vue';
import Inroom from '~/components/Inroom.vue';
import Collapse from '~/components/collapse/Collapse.vue';
import DdButton from '~/components/DdButton.vue';
import NavigationBar from '~/components/navigation/CourseNavigationBar.vue';
import { useReportCardStore } from '~/stores/reportCard';
export default {
  name: "modulePage",
  components: {
    CasesPanel: function CasesPanel() {
      return import('~/components/panels/CasesPanel.vue');
    },
    PanelButton: PanelButton,
    TheoryCourse: function TheoryCourse() {
      return import('~/components/CourseModule/Theory.vue');
    },
    PracticeCourse: function PracticeCourse() {
      return import('~/components/CourseModule/Practice.vue');
    },
    CreativeCourse: function CreativeCourse() {
      return import('~/components/CourseModule/Creative.vue');
    },
    Comments: function Comments() {
      return import('~/components/comments/Comments.vue');
    },
    Dials: Dials,
    Card: Card,
    Inroom: Inroom,
    Collapse: Collapse,
    DdButton: DdButton,
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    SubWell: function SubWell() {
      return import('~/components/cards/SubWell.vue');
    },
    NotifyPanel: function NotifyPanel() {
      return import('~/components/panels/NotifyPanel.vue');
    },
    NavigationBar: NavigationBar
  },
  scrollToTop: true,
  head: function head() {
    return {
      title: "".concat(this.module.title, " \u2014 ").concat(this.course.name, " | Creative Practice")
    };
  },
  data: function data() {
    return {
      course: {},
      modules: [],
      module: {
        title: '',
        image: null,
        brief: null,
        info: null,
        rateStart: null,
        rateEnd: null,
        fileRequirements: null,
        noSubModules: true
      },
      card: {},
      iterations: {},
      helperClosed: false,
      access: {
        hasAccess: false,
        reason: null
      },
      materialsHidden: false,
      accesses: [],
      error: null,
      errorStatus: null,
      notifyMessage: 'course_module_release'
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $axios, route, app, error, redirect, $appStore, params, promises, $reportCardStore, err, result, _result, data, moduleData, loc;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $axios = _ref.$axios, route = _ref.route, app = _ref.app, error = _ref.error, redirect = _ref.redirect, $appStore = _ref.$appStore;
            $appStore.$patch({
              activeApp: 'learning'
            });
            params = {
              course: route.params.course,
              module: route.params.module
            };
            promises = [$axios.$get("".concat($axios.defaults.baseURL, "/coursemodule/get"), {
              params: params
            }), $axios.$get("".concat($axios.defaults.baseURL, "/course/getmodules"), {
              params: {
                slug: route.params.course
              }
            })];
            $reportCardStore = useReportCardStore();
            if (!$reportCardStore.hydrated) {
              promises.push($reportCardStore.hydrate());
            }
            err = null;
            _context.next = 9;
            return Promise.all(promises).catch(function (e) {
              err = e;
            });
          case 9:
            result = _context.sent;
            if (!err) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", error({
              statusCode: 404,
              message: 'Модуль не знайдено'
            }));
          case 12:
            _result = _slicedToArray(result, 2), data = _result[0], moduleData = _result[1];
            if (!(!data || !data.card)) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", redirect("/learning/course/".concat(params.course, "/about")));
          case 15:
            if (!data.error) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", {
              error: data.error,
              errorStatus: data.status
            });
          case 17:
            if (!(data.card && data.card.locale)) {
              _context.next = 26;
              break;
            }
            _context.t0 = regeneratorRuntime.keys(data.course.slugMap);
          case 19:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 26;
              break;
            }
            loc = _context.t1.value;
            if (!(data.course.slugMap[loc] == route.params.course)) {
              _context.next = 24;
              break;
            }
            if (!(loc !== data.card.locale && data.course.slugMap[loc])) {
              _context.next = 24;
              break;
            }
            return _context.abrupt("return", redirect(app.localePath("/learning/course/".concat(data.course.slugMap[data.card.locale], "/module/").concat(params.module))));
          case 24:
            _context.next = 19;
            break;
          case 26:
            if (!moduleData.error) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return", {
              error: moduleData.error,
              errorStatus: moduleData.status
            });
          case 28:
            return _context.abrupt("return", {
              course: data.course,
              modules: moduleData.modules,
              module: data.module,
              card: data.card,
              iterations: data.iterations,
              columns: data.columns,
              access: data.access,
              materialsHidden: data.materialsHidden,
              accesses: data.accesses
            });
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeMount: function beforeMount() {
    if (process.browser) {
      this.$socket.on('connect', this.connect);
      this.connect();
    }
  },
  mounted: function mounted() {
    var helper = JSON.parse(window.localStorage.getItem(this.localHelperId));
    this.helperClosed = helper && helper.closed;
  },
  computed: {
    chatPlaceholderKey: function chatPlaceholderKey() {
      var key = 'module';
      if (this.course.type == 'event') {
        key = this.module.type == 'practice' ? 'workshop' : 'lecture';
      }
      return "chatPlaceholder.".concat(key);
    },
    collapseStore: function collapseStore() {
      return useCollapseStore();
    },
    moduleReleased: function moduleReleased() {
      var released = !this.module.awaiting;
      if (this.module.releaseAt) {
        released = new Date() > new Date(this.module.releaseAt);
      }
      return released;
    },
    studentMark: function studentMark() {
      return this.card && this.card.averageMark || 0;
    },
    localHelperId: function localHelperId() {
      return "module-".concat(this.module.id, "-helpers");
    },
    progMod: function progMod() {
      var _this = this;
      return this.course.program.find(function (o) {
        return o.module == _this.module.id;
      });
    },
    now: function now() {
      return useTimeStore().now;
    },
    testLink: function testLink() {
      // remove last slash in path
      var routePath = this.$route.path;
      if (routePath.slice(-1) !== '/') routePath = routePath + '/';
      return "".concat(routePath, "test");
    },
    result: function result() {
      var _this2 = this;
      if (!this.card || !this.card.modules) return false;
      return this.card.modules.find(function (o) {
        return o.module == _this2.module.id;
      });
    },
    cooldown: function cooldown() {
      // if (this.module.type == 'practice') {
      //     return this.card.practiceCooldown
      //          ? new Date(this.card.practiceCooldown)
      //          : false;
      // }
      return this.result && this.result.cooldown ? new Date(this.result.cooldown) : false;
    },
    isCooldown: function isCooldown() {
      if (!this.cooldown) return false;
      return this.now < this.cooldown;
    },
    passed: function passed() {
      return this.result ? this.result.passed : false;
    },
    moduleFinished: function moduleFinished() {
      var isFinished = this.result && this.result.mark == 100 && !this.course.testMode;
      if (this.module.type == 'practice' && isFinished) {
        isFinished = this.iterations.some(function (o) {
          return o.hasStar;
        });
      }
      return isFinished;
    },
    payWall: function payWall() {
      return !this.access.hasAccess;
    },
    hasMultipleLangs: function hasMultipleLangs() {
      if (!this.course.slugMap) return false;
      return Object.keys(this.course.slugMap).length > 1;
    },
    courseLocale: function courseLocale() {
      var locale = null;
      if (!this.course.slugMap) return locale;
      for (var localeKey in this.course.slugMap) {
        if (this.course.slugMap[localeKey] == this.course.slug) {
          locale = localeKey;
        }
      }
      return locale;
    },
    subscriptionStore: function subscriptionStore() {
      return useSubscriptionStore();
    },
    canDownload: function canDownload() {
      var _this3 = this;
      // This module not included in subsctiption
      if (this.module.requiredAccess && !this.module.requiredAccess.some(function (id) {
        return ['6101170ec90aff6d4fe9577b', '64624a54006c56df40edb821'].includes(id);
      })) {
        return null;
      }
      ;
      return this.access && this.access.allowDownloadVideo;

      // Disabled in audition mode
      var requires = this.course.program.find(function (o) {
        return o.module == _this3.module.id;
      }).requires;
      if (requires) {
        var _iterator = _createForOfIteratorHelper(requires),
          _step;
        try {
          var _loop = function _loop() {
              var reqId = _step.value;
              var result = _this3.card.modules.find(function (o) {
                return o.module == reqId;
              });
              if (!result || !result.passed) return {
                v: false
              };
            },
            _ret;
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      // This is a free module
      if (!this.module.requiredAccess || !this.module.requiredAccess.length) return true;

      // Download is not available in trial
      var token = this.subscriptionStore.token;
      if (token.isTrial) return false;

      // if (token && token.end) {
      //     let end = new Date(token.end);
      //     if (end < this.now) token = null;
      // }

      // if (!token || token.isTrial) return false;

      return true;
    }
  },
  watch: {
    helperClosed: {
      handler: function handler(val) {
        if (val) this.collapseStore.remove('module-helper');else this.collapseStore.add('module-helper');
      },
      immediate: true
    }
  },
  methods: {
    setCardLocale: function setCardLocale(locale) {
      var _this4 = this;
      if (!this.card) {
        return this.$router.replace(this.localePath("/learning/course/".concat(this.course.slugMap[locale])));
      }
      var moduleSlug = this.$route.params.module;
      var params = {
        locale: locale,
        course: this.course.id
      };
      this.$axios.post('/reportcard/setLocale/', params).then(function (response) {
        _this4.$router.replace(_this4.localePath("/learning/course/".concat(_this4.course.slugMap[locale], "/module/").concat(moduleSlug)));
      }).catch(function (err) {
        console.log(err);
      });
    },
    connect: function connect() {
      if (this.access.hasAccess) {
        this.$socket.get("/user/joinRoom/", {
          roomName: "course-".concat(this.course.id)
        });
        this.$socket.get("/user/joinRoom/", {
          roomName: "course-".concat(this.course.id, "-").concat(this.module.id)
        });
      }
    },
    toggleHelper: function toggleHelper() {
      if (process.browser) {
        this.helperClosed = !this.helperClosed;
        var data = {
          closed: this.helperClosed
        };
        window.localStorage.setItem(this.localHelperId, JSON.stringify(data));
      }
    },
    updateWatchMode: function updateWatchMode(state) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.$set(_this5.card, 'watchMode', state);

              // We receive data about module access from the server, so update
              // TODO: refactor
              params = {
                course: _this5.$route.params.course,
                module: _this5.$route.params.module
              };
              _context2.next = 4;
              return _this5.$axios.$get("".concat(_this5.$axios.defaults.baseURL, "/coursemodule/get"), {
                params: params
              }).catch(function (e) {
                console.log(e);
              });
            case 4:
              data = _context2.sent;
              if (data !== null && data !== void 0 && data.access) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              _this5.module = data.module;
              _this5.iterations = data.iterations;
              _this5.columns = data.columns;
              _this5.access = data.access;
              _this5.materialsHidden = data.materialsHidden;
              _this5.accesses = data.accesses;
              _this5.$cropContent();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    updateModule: function updateModule(newModule) {
      this.module.title = newModule.title;
      this.module.image = newModule.image;
      this.module.info = newModule.info;
      this.module.brief = newModule.brief;
      this.module.rateEnd = newModule.rateEnd;
      this.module.rateStart = newModule.rateStart;
      this.module.fileRequirements = newModule.fileRequirements;
      this.module.noSubModules = newModule.noSubModules;
    },
    showNotifyDialog: function showNotifyDialog(message) {
      this.notifyMessage = message;
      this.$modalityStore.openModal({
        type: 'drawer',
        name: 'notify'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (process.browser) {
      this.$socket.get("/user/leaveRoom/", {
        roomName: "course-".concat(this.course.id)
      });
      this.$socket.get("/user/leaveRoom/", {
        roomName: "course-".concat(this.course.id, "-").concat(this.module.id)
      });
    }
  }
};